import Paragraph from '@stories/Components/Global/Typography/Paragraph';
import React from 'react';
import S from '@stories/Components/Content/IntroductionContent/IntroductionContent.styles';
const IntroductionContent = (props) => {
    return (React.createElement(S.Wrapper, { centerText: props.centerText },
        props.title && React.createElement(S.Title, null, props.title),
        props.text && (React.createElement(Paragraph, { size: "large", align: "center" }, props.text))));
};
export default IntroductionContent;
